import $ from 'jquery';

if (window.dflipSrc) {
    let script = document.createElement('script');
    script.onload = () => {
        setTimeout(() => {
            const flipbookContainers = document.querySelectorAll('.flipbook-container');
            for (let flipbookContainer of flipbookContainers){
                const pdf = flipbookContainer.getAttribute('data-src');

                if (pdf) {
                    const options = { height: '100%', duration: 800 };
                    const flipBook = $(flipbookContainer).flipBook(pdf, options);
                }
            }

        }, 1000);
    };

    script.src = window.dflipSrc;

    if (window.jQuery === undefined) {
        window.jQuery = $;
    }
    document.body.appendChild(script);
}